module.exports = __webpack_public_path__ + "static/media/m3swhite.8cad9799.png";